/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 18
// module chunks = 1